<template>
<div class="CommodityAdd">
	<div class="type">选择商品分类</div>
	<div class="step_bar">
		<el-steps :active="stepActive" finish-status="success" align-center>
			<el-step title="填写软件商品信息"></el-step>
			<el-step title="填写软件商品展示内容"></el-step>
			<el-step title="填写交付信息"></el-step>
		</el-steps>
	</div>

	<div class="formBox">
		<el-form ref="form" :model="Myform" label-width="110px" :label-position="'left'" :rules="rules">
			<!-- 步骤一  商品信息 -->
			<div v-show="stepActive === 0" class="step0">
				<!-- <el-form-item label="商品类型" class="form_item">
					<div class="isFlex">
						<el-select v-model="Myform.goodsInfo.goodsCategory" disabled placeholder="请选择商品类型" size="small"
							auto-complete="" style="width: 250px">
							<el-option label="基础数据" :value="1"></el-option>
							<el-option label="数据产品" :value="2"></el-option>
							<el-option label="软件产品" :value="3"></el-option>
						</el-select>
					</div>
				</el-form-item> -->
				<transition name="el-fade-in-linear">
					<el-form-item label="软件分类" class="form_item">
						<div style="display: flex;margin-bottom: 5px;flex-wrap: wrap;">
							<div class="btn" v-for="(button, i) in applicationList" :key="i" size="mini"
								style="margin: 4px 3px" :class="{ isclick: selectbuttons == button.id }"
								@click="selectapplication(button.id)">
								{{ button.name }}
							</div>
						</div>
					</el-form-item>
				</transition>
				<el-form-item label="商品名称" prop="goodsInfo.goodsName" class="form_item"
					style="margin-bottom: 12px;">
					<el-input v-model="Myform.goodsInfo.goodsName" size="small"
						placeholder="商品名称不可重复，要求与服务紧密相关，2～30个字"></el-input>
				</el-form-item>

				<!-- <el-form-item label="所属区域" class="form_item">
					<citySingle :sendCityInfo="acceptCityInfo" @getCityInfo="getCityInfoFun" style="width: 100%">
					</citySingle>
				</el-form-item> -->
				<el-form-item label="商品描述">
					<el-input type="textarea" v-model="Myform.goodsInfo.goodsDescribe" :rows="4" maxlength="100"
						show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="商品价格" class="form_item">
					<div class="isFlex">
						<el-select v-model="Myform.goodsInfo.goodsPriceType" placeholder="请选择活动区域" size="small"
							style="width: 250px;">
							<el-option label="免费" :value="3"></el-option>
							<el-option label="面议" :value="2"></el-option>
							<el-option label="商品金额" :value="1"></el-option>
						</el-select>
						<el-input v-show="Myform.goodsInfo.goodsPriceType === 1" size="small" @input="GreaterZero1()"
							v-model.number="Myform.goodsInfo.goodsPrice" style="margin-left: 8px;width: 200px;"
							placeholder="填写价格"></el-input>
					</div>
				</el-form-item>
				<el-form-item label="商品图片">
					<div class="imgList">
						<el-upload class="avatar-uploader" :file-list="GoodsImgFileList" list-type="picture-card"
							:action="this.$const.common.fileUpload" :on-remove="handleRemoveGoodsImg"
							:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
							<i class="el-icon-plus avatar-uploader-icon" style="width:145px;line-height:145px"></i>
							<div slot="tip" class="el-upload__tip">商品图片大小不超过5M</div>
						</el-upload>
					</div>
				</el-form-item>
				<el-form-item label="说明文档">
					<div>
						<el-upload :auto-upload="false" class="upload-demo" action="#" accept=".docx, .pdf"
							:on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
							:on-change="uploadFile" multiple :limit="1" :on-exceed="handleExceed" :file-list="fileList">
							<el-button type="primary" size="small">上传附件</el-button>
							<div slot="tip" class="el-upload__tip">只能上传docx/pdf文件，上传文件大小不能超过 20MB!</div>
						</el-upload>
					</div>
				</el-form-item>
				<el-form-item label="商品规格" class="form_item">
					<div class="isFlex">
						<el-select v-model="Specifica" placeholder="请选择商品规格" size="small" style="width: 250px;">
							<el-option label="无规格" :value="1"></el-option>
							<el-option label="添加规格" :value="2"></el-option>
						</el-select>
					</div>
				</el-form-item>
				<div v-if="Specifica == 2">
					<el-form-item label="规格名称" class="form_item">
						<el-tag style="cursor: pointer" :effect="currentTagIndex === index ? 'dark' : 'light'"
							@click="clicktag(index)" :key="index" v-for="(tag, index) in Myform.specificaKeyValue"
							closable :disable-transitions="false" @close="handleClose(tag)">
							{{ tag.key }}
						</el-tag>
						<el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput"
							size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
						</el-input>
						<el-button v-else class="button-new-tag" @click="showInput">+</el-button>
					</el-form-item>

					<el-form-item label="规格值" v-if="Myform.specificaKeyValue.length > 0">
						<div>
							<el-tag :key="index" type="success"
								v-for="(tag, index) in Myform.specificaKeyValue[currentTagIndex].value" closable
								:disable-transitions="false" @close="handleCloseValue(currentTagIndex, index)">
								{{ tag }}
							</el-tag>
							<el-input class="input-new-tag" v-if="inputVisibleValue" v-model="inputValueValue"
								ref="saveTagInputValue" size="small" @keyup.enter.native="handleInputConfirmValue"
								@blur="handleInputConfirmValue">
							</el-input>
							<el-button v-else class="button-new-tag" @click="showInputValue">+</el-button>
						</div>
					</el-form-item>
				</div>
			</div>


			<!-- 步骤二   商品参数数据信息 -->
			<div v-show="stepActive === 1" class="step1">
				<div id="editor-box"></div>
				<!-- <template>
					<el-table :data="tableData" height="500" style="width: 100%">
						<el-table-column label="商品描述">
							<template v-slot="{ row, $index }">
								<span v-html="row.goodsSpec"></span>
							</template>
						</el-table-column>
						<el-table-column label="价格类型与价格">
							<template v-slot="{ row, $index }">
								<div class="isFlex">
									<el-select v-model="row.goodsPriceType" placeholder="请选择商品金额" size="small"
										style="width: 250px;">
										<el-option label="免费" :value="3"></el-option>
										<el-option label="面议" :value="2"></el-option>
										<el-option label="商品金额" :value="1"></el-option>
									</el-select>
									<el-input v-show="row.goodsPriceType === 1" size="small"
										v-model.number="row.goodsPrice" @input="GreaterZero(row.goodsPrice, row)"
										style="margin-left: 8px;width: 200px;" placeholder="填写价格"></el-input>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</template> -->
			</div>
			<!-- 商品交付信息 -->
			<div v-show="stepActive === 2" class="step2">
				<el-form-item label="计费方式">
					<el-radio-group v-model="Myform.goodsInfo.chargingType">
						<el-radio :label="1">按次计费</el-radio>
						<el-radio :label="2">按周期计费</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="交付方式">
					<el-radio-group v-model="Myform.goodsInfo.deliveryType">
						<!-- <el-radio :label="1">线上交易</el-radio> -->
						<el-radio :label="2">线下预约交易</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="截止日期">
					<el-date-picker :disabled="long_term_effective" v-model="goodsInfo_endDate" type="date"
						placeholder="选择日期">
					</el-date-picker>
					<el-checkbox v-model="long_term_effective" style="margin-left: 20px">长期有效</el-checkbox>
				</el-form-item>
				<el-form-item label="交付时间">
					<el-radio-group v-model="deliveryDate">
						<el-radio label="实时">实时</el-radio>
						<el-radio label="天"></el-radio>
					</el-radio-group>
					<el-input v-if="deliveryDate === '天'" style="width: 80px;margin-left: 18px" size="small"
						v-model.number="day"></el-input>
				</el-form-item>
				<!-- <el-form-item label="数据下载地址">
					<el-input placeholder="请输入内容" v-model="Myform.goodsInfo.dataDownloadUrl"></el-input>
				</el-form-item> -->
			</div>
		</el-form>
	</div>
	<!-- 提交按钮 -->
	<div class="buttonBox">
		<el-button v-if="stepActive !== 0" @click="beforepro">上一步</el-button>
		<el-button @click="nextStep">{{ getnext }}</el-button>
	</div>
</div>
</template>

<script>
import dateformat from "@/utils/filter";
import citySingle from "@/components/citySingle.vue";
import { getClassificationofgoods, ProductSpecificationGeneration } from "../../../const/MerchantWorkbench";
import E from "wangeditor";
import hljs from "highlight.js";

export default {
	name: "CommodityAdd",
	components: { citySingle },
	props: {},
	directives: {},
	filters: {},
	extends: {},
	mixins: {},
	data() {
		return {

			message1: null,
			message: null,
			update: false,

			tableData: [],
			tableDataCopy: [],

			//添加规格值
			dynamicTagsValue: [],
			inputVisibleValue: false,
			inputValueValue: '',

			//添加规格
			specificaKeyValue: [],
			inputVisible: false,
			inputValue: '',
			currentTagIndex: -1,


			editID: '',
			data_parameter: [], //商品参数
			fileList: [], //上传附件
			GoodsImgFileList: [], //商品图片展示
			// data_category: '基础数据', //基础数据 产品数据
			selectbuttons: '',
			applicationList: [], //应用领域分类
			stepActive: 0, //步骤条选中
			long_term_effective: false,
			goodsInfo_endDate: '', //截止日期
			deliveryDate: '', //交付时间  实时  天
			day: '', //交付天数
			Specifica: 1, //规格
			Myform: {
				// "basicImageInfo": { //	影像基础信息
				//   "acceptingStation": "", //	接收站
				//   "acquisitionTime": "", //	采集时间
				//   "centerLatitude": "", //景中心纬度
				//   "centerLongitude": "", //景中心经度
				//   // "createTime": "",//	创建时间
				//   // "dataSetInfoId": "", //	数据服务id ; data_set_info.id
				//   // "goodsId": "",//商品id：goods.id
				//   // "id": "",//	主键
				//   "lowerLeftLatitude": "", //	左下纬度
				//   "lowerLeftLongitude": "", //	左下经度
				//   "lowerRightLatitude": "", //	右下纬度
				//   "lowerRightLongitude": "", //右下经度
				//   "pathwayNumber": "", //	轨道圈号
				//   "productEndTime": "", //	产品结束时间
				//   "productMiddleTime": "", //	产品中间行时间
				//   "productStartTime": "", //	产品起始时间
				//   "satellite": "", //卫星
				//   "scene": "", //	景Path/Row
				//   "sensor": "", //	传感器
				//   "substar": "", //星下点Path/Row
				//   // "updateTime": "",//	修改时间
				//   "upperLeftLatitude": "", //	左上纬度
				//   "upperLeftLongitude": "", //左上经度
				//   "upperRightLatitude": "", //	右上纬度
				//   "upperRightLongitude": "" //	右上经度
				// },
				"goodsInfo": { //	商品基础信息
					"chargingType": 0, //计费方式 1；按次收费；2.按周期收费
					// "checkTime": "", //审核时间
					// "checkUserId": 0, //	审核人id
					// "createTime": "", //创建时间
					// "createUserId": "", //创建人id：web_user_info.id
					"dataDownloadUrl": "", //数据下载地址
					"deliveryDate": 0, //交付时间 单位天，为空则为实时
					"deliveryType": 2, //交付方式 1：线上交易；2.线下预约交易
					"endDate": "", //截止日期，为空则长期有效
					"goodsDescribe": "", //商品描述
					"goodsCategory": 3, //商品类别：1.影像数据、2.数据产品、3.软件产品
					"goodsDocUrl": "", //商品说明文档链接
					"goodsName": "", //商品名称
					"goodsPrice": 0, //商品价格
					"goodsPriceType": 3, //商品价格类型：1：商品金额：2：面议；3：免费
					"goodsThumbnail": "", //快视图
					"goodsType": 1, //	商品类型：1：影像产品；2：产品数据 3.软件产品
					"provinceId": '', //省id
					"cityId": '', //	市id
					"countyId": '', //	县id
					"productPlateId": "", //应用领域：goods=2时有效；product_plate.id
					"satelliteCategoryId": "", //卫星类别
					// "shelfStatus": 0,//	状态：0.待上架；1.上架；2.已下架；
					// "status": 0,//	状态：0.待审核；1.审核通过；2.审核不通过；
					// "supplierId": "",//关联的supplier_info.id 商家id
					// "updateTime": ""//修改时间
				},
				"goodsExtension": {
					"goodsCategoryId": "", //	软件平台分类表goods_category.id
					"goodsId": "", //	商品表goods.id
					"goodsImg": [], //商品图片，多个以英文“,”隔开
					"goodsProductFunction": "", //	产品功能
					"goodsProductIntroduction": "", //产品介绍
					"goodsSpecList": "", //	商品规格列表json格式
					"id": "",
					"userScenarios": "" //	用户案例
				},
				"goodsSpecifica": [{ //	商品规格信息
					"goodsId": "",//	商品id
					"goodsPrice": 0,//	商品价格
					"goodsPriceType": 0,
					"goodsSpec": "",//	商品规格,json格式{'key':'value','key2':'value2',...}
					"id": ""//	主键
				}],
				"otherParam": { //	其他参数
					"cameraLookingDownAngle": "", //	相机俯视角
					"cameraView": "", //	相机前后视角
					// "createTime": "",//	创建时间
					// "dataSetInfoId": "", //	数据服务id ; data_set_info.id
					"gainMode": "", //	增益模式
					// "goodsId": "",//商品id：goods.id
					// "id": "",//	主键
					"integralLevel": "", //	积分级数
					"integralTime": "", //	积分时间，单位为秒
					"satelliteAzimuth": "", //	卫星方位角
					"sunAzimuth": "", //太阳方位角
					"satelliteHighAngle": "", //卫星高度角
					"solarAltitudeAngle": "", //太阳高度角
					"spAveragePitchingAngle": "", //	卫星平台（sp）平均俯仰角
					"spAverageYawAngle": "", //卫星平台(sp)平均航偏角
					"spRollingAngle": "", //卫星平台（sp）滚动角
					// "updateTime": ""//	修改时间
				},
				"specificaKeyValue": [],
				// "systemProductParam": { //	系统生产参数
				//   "cloudCover": 0, //	云覆盖量
				//   // "createTime": "",//	创建时间
				//   // "dataSetInfoId": "", //	数据服务id ; data_set_info.id
				//   "demDataSource": "", //DEM数据来源
				//   "earthModel": "", //	地球模型
				//   "ellipsoidModel": "", //	椭球模型
				//   "floatingRate": 0, //	浮动比例
				//   // "goodsId": "",//	商品id：goods.id
				//   // "id": "",//	主键
				//   "mapProjection": "", //	地图投影
				//   "originalDataStripNumber": "", //	原始数据条带号
				//   "productDataSize": 0, //	产品大小（单位MB）整数
				//   "productDate": "", //	生产日期
				//   "productDistinguishability": "", //	产品分辨率
				//   "productFormat": "", //	产品格式
				//   "productLevel": "", //	产品级别
				//   "productSerialNumber": "", //	产品序列号
				//   "productSpectralCoverage": "", //	产品谱段
				//   "productType": "", //	产品类型
				//   "productWidth": "", //	产品宽度（像素）
				//   "projectionNumber": "", //	投影带号
				//   "radiometricCorrectionMethod": "", //	辐射校正方法
				//   "resamplingMethod": "", //	重采样方法
				//   "sceneNumber": 0, //	连续景数
				//   "sceneSerialNumber": "", //	景序列号
				//   // "updateTime": ""//	修改时间
				// }
			},
			rules: {
				'goodsInfo.goodsName': [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
			},
			// 回显省市区信息
			acceptCityInfo: []
		};
	},
	computed: {
		getnext() {
			return this.stepActive === 2 ? '完成，发布商品' : '下一步'
		},
	},
	watch: {
		'Myform.specificaKeyValue'(newValue, oldValue) {
			console.log(newValue, oldValue);
			if (newValue.length === 0) {
				this.Specifica = 1
			}
		},

		Specifica(newValue) {
			if (newValue === 1) {
				this.Myform.specificaKeyValue = []
			}
			this.Myform.goodsInfo.goodsPrice = 0
		},
		//监听步骤，步骤为1，发送规格请求，获取规格
		stepActive(newValue) {
			if (newValue === 1) {
				if (this.editID != '' && this.Myform.goodsInfo.id) {
					if (this.update) {
						this.getProductSpecificationGeneration()
					}
				} else {
					this.getProductSpecificationGeneration()
				}
			}
		},

		selectbuttons(newValue) {
			this.Myform.goodsExtension.goodsCategoryId = newValue
		},
		'form.priceType'(newValue, oldValue) {
			this.form.currentPrice = ''
		},

		long_term_effective(newValue, oldValue) {
			this.Myform.goodsInfo.endDate = ''
		},
		goodsInfo_endDate(newValue, oldValue) {
			this.Myform.goodsInfo.endDate = dateformat.timeFormat(newValue)
		},
		deliveryDate(newValue, oldValue) {
			if (newValue === '实时') {
				this.Myform.goodsInfo.deliveryDate = ''
			}
		},
		day(newValue) {
			if (newValue) {
				this.Myform.goodsInfo.deliveryDate = newValue
			}
		},

	},
	created() {
		// this.data_parameter = mock.data_parameter
		this.getProduct()
	},
	mounted() {
		this.initEditor()
	},
	methods: {
		initEditor() {
			var _this = this;
			const editor = new E('#editor-box');
			// 配置菜单栏，设置不需要的菜单
			editor.config.showFullScreen = false;
			// 设置编辑器高度
			if (document.body.clientWidth > 1400) {
				editor.config.height = 380;
			} else {
				editor.config.height = 240;
			}
			editor.config.onchange = function (e) {
				_this.Myform.goodsExtension.goodsProductIntroduction = e;
			};
			// 代码高亮
			editor.highlight = hljs;
			// 一次最多上传 1 个图片
			editor.config.uploadImgMaxLength = 1;
			// 隐藏网络图片入口
			editor.config.showLinkImg = false;
			//圖片上传地址
			editor.config.uploadImgServer = this.$const.common.fileUpload;
			// 图片上传header参数设置
			// editor.config.uploadImgHeaders = _this.myHeaders;
			// 自定义参数名称
			editor.config.uploadFileName = 'file';
			//输入内容-触发时间为500ms每次
			editor.config.onchangeTimeout = 500;
			// 默认限制图片上传大小为5M
			editor.config.uploadImgHooks = {
				customInsert: function (insertImgFn, result) {
					// result 即服务端返回的接口
					// console.log('customInsert', result)
					if (result.code == 200) {
						let imgUrl = result.data;
						// insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
						insertImgFn(imgUrl);
					}

				}
			};
			editor.config.uploadVideoHeaders = this.myVideoHaders;
			// 配置视频上传地址
			editor.config.uploadVideoServer = this.$const.common.fileUpload;
			editor.config.uploadVideoName = 'file';
			editor.config.uploadVideoHooks = {
				customInsert: function (insertImgFn, result) {
					// result 即服务端返回的接口
					// console.log('customInsert', result)
					if (result.code == 200) {
						let imgUrl = result.data;
						// insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
						insertImgFn(imgUrl);
					}

				}
			};
			editor.create();

			// 商品编辑功能 内容展示
			if (this.$route.query.id) {
				this.editID = this.$route.query.id;
				// 加载当前商品数据
				this.$http.get(this.$const.common.getShopGoodsDesc + this.editID).then((res) => {
					if (res.code === 200) {
						this.Myform = res.data;

						if (this.Myform.specificaKeyValue.length > 0) {
							this.Specifica = 2
							this.currentTagIndex = this.Myform.specificaKeyValue.length - 1
							this.tableData = JSON.parse(JSON.stringify(res.data.goodsSpecifica))
							this.tableDataCopy = JSON.parse(JSON.stringify(res.data.goodsSpecifica))
							this.tableData.forEach((item, index) => {
								this.changeText(item.goodsSpec, index)
							})
						}

						this.acceptCityInfo = [
							this.Myform.goodsInfo.provinceName, this.Myform.goodsInfo.cityName, this.Myform.goodsInfo.countyName
						];

						this.selectbuttons = this.Myform.goodsExtension.goodsCategoryId

						this.fileList = [{
							name: this.Myform.goodsInfo.goodsName + '说明文档',
							url: this.Myform.goodsInfo.goodsDocUrl
						}];
						this.goodsInfo_endDate = this.Myform.goodsInfo.endDate;
						if (this.Myform.goodsInfo.endDate == '' || this.Myform.goodsInfo.endDate == null) {
							this.long_term_effective = true;
						}
						if (this.Myform.goodsInfo.deliveryDate == '' || this.Myform.goodsInfo.deliveryDate == null) {
							this.deliveryDate = '实时'
						} else {
							this.deliveryDate = '天'
							this.day = this.Myform.goodsInfo.deliveryDate;
						}
						var imgList = this.Myform.goodsExtension.goodsImg.split(',')
						editor.txt.html(this.Myform.goodsExtension.goodsProductIntroduction);
						imgList.forEach((item, i) => {
							if (item != '') {
								this.GoodsImgFileList.push({ name: item, url: item })
							}
						})

					}
				})
			}
		},

		GreaterZero1() {
			if (typeof this.Myform.goodsInfo.goodsPrice === 'string') {
				if (this.message1) {
					this.message1.close()
				}
				this.message1 = this.$message.warning('请输入数字')
				this.Myform.goodsInfo.goodsPrice = ''
				return
			}
			if (this.Myform.goodsInfo.goodsPrice <= 0) {
				if (this.message1) {
					this.message1.close()
				}
				this.message1 = this.$message.warning('请输入大于0的价格')
				this.Myform.goodsInfo.goodsPrice.goodsPrice = ''
			}
		},
		GreaterZero(value, row) {
			if (typeof value === 'string') {
				if (this.message) {
					this.message.close()
				}
				this.message = this.$message.warning('请输入数字')
				row.goodsPrice = ''
				return
			}
			if (value <= 0) {
				if (this.message) {
					this.message.close()
				}
				this.message = this.$message.warning('请输入大于0的价格')
				row.goodsPrice = ''
			}
		},

		changeText(item, index) {// 将对象格式化成字符串
			this.tableData[index].goodsSpec = item.slice(1, item.length - 1).replace(/,/g, '<br>').replace(/"/g, '').replace(/:/g, ' : ')
		},

		//获取规格
		async getProductSpecificationGeneration() {
			if (this.Myform.specificaKeyValue.length > 0) {
				let data = {
					specificaKeyValue: JSON.parse(JSON.stringify(this.Myform.specificaKeyValue))
				}
				let res = await this.$http.post(this.$const.MerchantWorkbench.ProductSpecificationGeneration, data)
				if (res.code === 200) {
					this.tableData = JSON.parse(JSON.stringify(res.data))
					this.tableDataCopy = JSON.parse(JSON.stringify(res.data))
					this.tableData.forEach((item, index) => {
						this.changeText(item.goodsSpec, index)
					})
				} else {
					this.$message.warning('请重试')
				}
			}
		},

		//添加规格值
		handleCloseValue(currentindex, index) {
			this.Myform.specificaKeyValue[currentindex].value.splice(this.dynamicTagsValue.indexOf(index), 1);
			this.update = true
		},

		showInputValue() {
			this.inputVisibleValue = true;
			this.$nextTick(_ => {
				this.$refs.saveTagInputValue.$refs.input.focus();
			});
		},

		handleInputConfirmValue() {
			let inputValue = this.inputValueValue;
			if (inputValue) {
				this.Myform.specificaKeyValue[this.currentTagIndex].value.push(inputValue);
				this.update = true
			}
			this.inputVisibleValue = false;
			this.inputValueValue = '';
		},


		clicktag(index) {
			this.currentTagIndex = index
		},

		handleClose(tag) {
			this.Myform.specificaKeyValue.splice(this.Myform.specificaKeyValue.indexOf(tag), 1);
			this.currentTagIndex = this.Myform.specificaKeyValue.length - 1
			this.update = true
		},

		showInput() {
			this.inputVisible = true;
			this.$nextTick(_ => {
				this.$refs.saveTagInput.$refs.input.focus();
			});
		},

		handleInputConfirm() {
			let inputValue = this.inputValue;
			if (inputValue) {
				this.Myform.specificaKeyValue.push({
					key: inputValue,
					value: []
				});
				this.update = true
			}
			this.inputVisible = false;
			this.inputValue = '';
			this.currentTagIndex = this.Myform.specificaKeyValue.length - 1
		},

		// 获取省市区信息
		getCityInfoFun(value) {
			console.log('获取省市区信息', value);
			this.Myform.goodsInfo.provinceId = value[0];
			this.Myform.goodsInfo.cityId = value[1];
			this.Myform.goodsInfo.countyId = value[2];
		},
		// 初始加载接口参数
		async getProduct() {
			try {
				// 应用领域数据
				let res = await this.$http.get(this.$const.MerchantWorkbench.getClassificationofgoods)
				if (res.code === 200) {
					this.applicationList = res.data
					this.selectbuttons = this.applicationList[0].id
					console.log(this.applicationList)
				}

			} catch (e) {
				this.$message.error(e)
			}
		},
		// 上传快视图前
		beforeAvatarUpload(file) {
			const isJPG = file.type === "image/jpeg" ||
				file.type === "image/jpg" ||
				file.type === "image/png" ||
				file.type === "image/PNG" ||
				file.type === "image/JPG";
				const isLt2M = file.size / 1024 < 5000;
			if (!isJPG) {
				this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
			}
			if (!isLt2M) {
				this.$message.error('上传图片大小不能超过 5M !');
			}
			return isJPG && isLt2M;
		},
		// 上传快视图成功
		handleAvatarSuccess(res, file) {
			// this.Myform.goodsExtension.goodsImg = res.data
			this.GoodsImgFileList.push({ name: res.data, url: res.data })
		},
		handleRemoveGoodsImg(file, fileList) {
			console.log(file, fileList);
			this.GoodsImgFileList = fileList;
		},
		//上传前检测
		handlebeforeUpload(file, fileList) {
			const extension = file.name.split('.')[1] === 'docx' || file.name.split('.')[1] === 'pdf';
			const isLt2M = file.size / 1024 / 1024 < 20; //根据需求是否需要对上传文件大小进行限制
			if (!extension) {
				this.$message({
					message: '上传文件只能是 docx、pdf格式!',
					type: 'warning'
				});
			}
			if (!isLt2M) {
				this.$message({
					message: '上传文件大小不能超过 20MB!',
					type: 'warning'
				});
			}
			return extension && isLt2M;
		},
		// 过滤重复
		filterRepetition(arr) {
			let arr1 = []; //存id
			let newArr = []; //存新数组
			for (let i in arr) {
				if (arr1.indexOf(arr[i].name) == -1) {
					arr1.push(arr[i].name);
					newArr.push(arr[i]);
				}
			}
			return newArr;
		},
		async uploadFile(file, filelist) {
			let flag = this.handlebeforeUpload(file, filelist)
			if (flag) {
				let arr = this.filterRepetition(filelist);
				if (arr.length !== filelist.length) {
					this.$notify.info({
						title: '提醒',
						message: '上传重复文件，已过滤重复文件',
						duration: 2000
					});
				}
				this.fileList = arr;
				let formData = this.setFormData()
				try {
					let res = await this.$http.post(this.$const.common.fileUpload, formData)
					if (res.code === 200) {
						this.$message.success('上传成功')
						this.Myform.goodsInfo.goodsDocUrl = res.data
					} else {
						this.$message.warning(res.msg)
					}
				} catch (e) {
					this.$message.warning(e)
				}

			} else {
				let copy = [...this.fileList]
				this.fileList = copy
			}
		},
		//移除附件
		handleRemove(file, fileList) {
			this.fileList = fileList
			this.Myform.goodsInfo.goodsDocUrl = ''
		},
		handlePreview(file) {
			console.log(file);
		},
		handleExceed(files, fileList) {
			this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		},
		beforeRemove(file, fileList) {
			return this.$confirm(`确定移除 ${file.name}？`);
		},
		// 应用领域选中
		selectapplication(button) {
			this.selectbuttons = button
		},
		setFormData() {
			if (this.fileList.length === 0) {
				this.$message.success('请上传文件');
				return;
			}
			let formData = new FormData(); //  用FormData存放上传文件
			this.fileList.forEach((file) => {
				formData.append(`file`, file.raw); // file.raw
			});

			return formData
		},
		// 上一步
		beforepro() {
			this.stepActive--
		},
		// 下一步 || 提交上架
		async nextStep() {
			this.$refs['form'].validate(valid => {
				if(!valid) {
					this.$message.error('存在信息未填写')
					throw '存在信息未填写'
				}
			})
			if (++this.stepActive > 2) {
				if (this.GoodsImgFileList) {
					this.Myform.goodsExtension.goodsImg = "";
					this.GoodsImgFileList.forEach((item, i) => {
						this.Myform.goodsExtension.goodsImg = this.Myform.goodsExtension.goodsImg + item.url + ','
					})
				}
				if (this.editID != '' && this.Myform.goodsInfo.id) {
					if (this.tableData.length > 0) {
						for (let index in this.tableData) {
							this.tableDataCopy[index].goodsPriceType = this.tableData[index].goodsPriceType
							this.tableDataCopy[index].goodsPrice = this.tableData[index].goodsPrice
						}
					}

					this.Myform.goodsSpecifica = this.tableDataCopy
					this.Myform.goodsInfo.goodsThumbnail = this.Myform.goodsExtension.goodsImg && this.Myform.goodsExtension.goodsImg.split(',')[0]
					// 修改商品
					try {
						let res = await this.$http.post(this.$const.MerchantWorkbench.product_update, this.Myform)
						if (res.code === 200) {
							this.$message.success('修改成功')
							var that = this;
							// setTimeout(function () {
							// 	that.$router.go(0)
							// }, 1000)
							that.$router.push({
									name: 'SellerCenter',
									query: {
										type: 'CommodityList'
									}
								})
						}
					} catch (e) {
						this.$message.error(e)
					}
				} else {
					// 新增商品发布
					if (this.tableData.length > 0) {
						for (let index in this.tableData) {
							this.tableDataCopy[index].goodsPriceType = this.tableData[index].goodsPriceType
							this.tableDataCopy[index].goodsPrice = this.tableData[index].goodsPrice
						}
					}

					this.Myform.goodsSpecifica = this.tableDataCopy
					this.Myform.goodsInfo.goodsThumbnail = this.Myform.goodsExtension.goodsImg && this.Myform.goodsExtension.goodsImg.split(',')[0]

					try {
						let res = await this.$http.post(this.$const.MerchantWorkbench.product_release, this.Myform)
						if (res.code === 200) {
							this.$message.success('发布成功')
							var that = this;
							// setTimeout(function () {
								// that.$router.go(0)
								that.$router.push({
									name: 'SellerCenter',
									query: {
										type: 'CommodityList'
									}
								})
							// }, 1000)
						}
					} catch (e) {
						this.$message.error(e)
					}
				}

				this.stepActive = 0
			}
		}
	},
};
</script>

<style>
.el-tag+.el-tag {
	margin-left: 10px;
}

.button-new-tag {
	margin-left: 10px;
	height: 32px;
	line-height: 30px;
	padding-top: 0;
	padding-bottom: 0;
}

.input-new-tag {
	width: 90px;
	margin-left: 10px;
	vertical-align: bottom;
}
</style>

<style lang="scss" scoped>
#editor-box {
	width: 100%;
	margin: 25px auto;
	border-radius: 8px;
	background-color: #ffffff;
	//padding: 10px;
	box-sizing: border-box;
	z-index: 197 !important;
	position: relative;
}

.CommodityAdd {
	.type {
		height: 50px;
		line-height: 50px;
		font-size: 20px;
		font-weight: 600;
		color: #444;
	}

	.step_bar {
		width: 80%;
		margin: 0 auto;

		::v-deep .el-step__head.is-process {
			color: #3868e9;
			border-color: #3868e9;
		}

		::v-deep .el-step__title.is-process {
			color: #3868e9;
		}

		::v-deep .el-step__head.is-success {
			color: #3868e9;
			border-color: #3868e9;
		}

		::v-deep .el-step__title.is-success {
			color: #3868e9;
		}
	}

	.formBox {
		min-height: 400px;
		width: 950px;
		margin: 20px auto;

		.step0 {
			.keywordsdesc {
				font-size: 12px;
				margin: 0 0 5px 0;
				padding-left: 110px;
				color: #a5a5a5;
			}

			.imgList {
				margin: 10px 0;

				.el-upload__tip {
					margin-top: 6px;
					line-height: normal;
				}
			}

			.form_item {
				min-height: 50px;
			}

			.inputWidth {
				width: 400px;
			}

			.el-form-item {
				margin-bottom: 0;
			}

			.btn {
				padding: 0px 15px;
				color: #666666;
				background: none;
				cursor: pointer;
				border: 1px solid rgba(204, 204, 204, 0.9);
				height: 36px;
				line-height: 36px;
			}

			.isclick {
				color: #3868e9;
				background: #3867e90a;
				border: 1px solid #3868e9;
				position: relative;
			}

			.isclick::after {
				content: '';
				// display: block;
				position: absolute;
				top: -1px;
				left: -1px;
				width: 10px;
				height: 10px;
				background-image: url('../../../assets/imgs/home/rightJiao.svg');
			}
		}

		.step1 {
			.table_infoItemLeft {
				display: flex;
				align-items: center;
				width: 50%;
				padding: 0 10px;
				height: 30px;
				line-height: 30px;
				background: #d1e4f0;
				text-align: right;
				justify-content: flex-end;
				color: #444;
			}

			.table_infoItemRight {
				display: flex;
				align-items: center;
				width: 50%;
				padding: 0 10px;
				background: #dfeaf0;
				height: 30px;
				line-height: 30px;
				color: #333;
			}

			.table_datetimeRight {
				display: flex;
				align-items: center;
				width: 50%;
				padding: 0 10px;
				background: #dfeaf0;
				height: 30px;
				line-height: 30px;
				color: #333;


				/deep/ .el-input__inner {
					background: #dfeaf0;
					padding: 0;
					padding-left: 17px;
					border: none;
					height: 28px;
					line-height: 28px;
					font-size: 13px;
					cursor: pointer;
				}

				/deep/ .el-input__prefix {
					left: 0px;
				}
			}

			.table_infoItem {
				display: flex;
				align-items: center;
				width: 33.3%;
				font-size: 12px;
				margin-bottom: 5px;
			}

			.table_infoBox {
				display: flex;
				flex-wrap: wrap;
				align-items: center;
			}

			.tableBox {
				//padding: 0 20px;
				margin-bottom: 10px;
			}

			.table_title {
				color: #aaa;
				padding-left: 40px;
				height: 30px;
				line-height: 30px;
				background-color: #e6f2ff;
			}

			.detailInfo_LitleTitle {
				margin: 0 20px 10px;
				border-left: 4px solid #2469f1;
				padding-left: 10px;
				color: #2469f1;
			}
		}

		.step2 {
			padding: 0 130px;
		}
	}

	.buttonBox {
		display: flex;
		justify-content: center;
	}
}
</style>